import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowLeft, ImageOff } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import CompareSlider from "../components/CompareSlider";
import { site } from "../mock";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BeforeAfter() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/before-after`)
      .then((res) => setItems(res.data))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-[#F7F2EA] min-h-screen">
      <Navbar />

      <section className="bg-[#0C0C0C] pt-36 pb-20 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center gap-4 mb-3">
            <span className="gold-divider" />
            <span className="text-xs tracking-[0.25em] text-[#8A857A] uppercase">Real Results</span>
          </div>
          <h1 className="font-serif-display text-5xl md:text-7xl text-[#F7F2EA]">Before &amp; After</h1>
          <p className="text-[#9E988B] font-light max-w-2xl mt-6 leading-relaxed">
            Drag the slider on each set to reveal the transformation. Individual results vary — book a
            complimentary consultation to design your personalized treatment plan.
          </p>
        </div>
      </section>

      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto">
          {loading ? (
            <p className="text-center text-[#8A857A] py-20">Loading gallery…</p>
          ) : items.length === 0 ? (
            <div className="text-center py-24 border border-dashed border-[#D8CCB8]">
              <ImageOff className="mx-auto text-[#C6A15B] mb-4" size={40} strokeWidth={1.2} />
              <p className="font-serif-display text-2xl text-[#1A1A1A] mb-2">Gallery coming soon</p>
              <p className="text-[#8A857A] text-sm">
                Before &amp; after photos will appear here once added.
              </p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 gap-10">
              {items.map((it) => (
                <div key={it.id} className="bg-white border border-[#E4DBCB] overflow-hidden">
                  {it.composite_image ? (
                    <img
                      src={it.composite_image}
                      alt={it.title}
                      className="w-full h-auto block"
                    />
                  ) : (
                    <CompareSlider before={it.before_image} after={it.after_image} />
                  )}
                  <div className="p-6">
                    {it.treatment ? (
                      <span className="text-[11px] tracking-[0.2em] uppercase text-[#C6A15B]">
                        {it.treatment}
                      </span>
                    ) : null}
                    <h3 className="font-serif-display text-2xl text-[#1A1A1A] mt-1">{it.title}</h3>
                    {it.description ? (
                      <p className="text-sm text-[#4A463F] font-light mt-2 leading-relaxed">
                        {it.description}
                      </p>
                    ) : null}
                  </div>
                </div>
              ))}
            </div>
          )}

          <div className="mt-16 text-center flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={site.bookUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#0C0C0C] text-[#C6A15B] text-xs tracking-[0.2em] uppercase px-9 py-4 hover:bg-[#1a1a1a] transition-colors"
            >
              Book a Consultation
            </a>
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-[#8A857A] hover:text-[#C6A15B] transition-colors"
            >
              <ArrowLeft size={16} /> Back Home
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
